"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const client = require("@prismicio/client");
const usePrismicPreviewStore = require("../usePrismicPreviewStore.cjs");
const getClient = (pluginOptions) => {
  const state = usePrismicPreviewStore.usePrismicPreviewStore.getState();
  if (state.client) {
    return state.client;
  } else {
    const client$1 = client.createClient(pluginOptions.apiEndpoint || pluginOptions.repositoryName, {
      accessToken: pluginOptions.accessToken,
      routes: pluginOptions.routes,
      defaultParams: {
        lang: pluginOptions.lang || "*",
        fetchLinks: pluginOptions.fetchLinks,
        graphQuery: pluginOptions.graphQuery,
        predicates: pluginOptions.predicates
      }
    });
    state.setClient(client$1);
    return client$1;
  }
};
exports.getClient = getClient;
//# sourceMappingURL=getClient.cjs.map
